// extracted by mini-css-extract-plugin
module.exports = {"toasts-container":"toasts-container-oKECy","router":"router-_65XU","error-container":"error-container-VZXwH","loader-container":"loader-container-vwvnb"};